import { motion } from "framer-motion";
import { MapPin, Car, AlertTriangle, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./FloatingButtons";
import { waLink } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

export const FinalCta = () => {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-[#D50000] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <span className="font-mono-t text-xs font-semibold uppercase tracking-[0.25em] text-black">
            Atendimento Imediato
          </span>
        </Reveal>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mt-4 font-display text-[16vw] font-bold uppercase leading-[0.85] tracking-tighter text-white sm:text-[13vw] lg:text-[11rem]"
        >
          Guincho<br />Agora
        </motion.h2>

        <div className="mt-10 grid gap-10 lg:grid-cols-2 lg:items-end">
          <Reveal delay={0.1}>
            <p className="max-w-md text-lg text-white/90">
              Clique no WhatsApp e envie sua localização, o modelo do veículo e o
              problema. Cuidamos do resto.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {[
                { icon: MapPin, label: "Localização" },
                { icon: Car, label: "Modelo" },
                { icon: AlertTriangle, label: "Problema" },
              ].map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className="flex items-center gap-2 border border-black/30 px-4 py-2 text-sm font-semibold uppercase tracking-wide text-black"
                >
                  <Icon size={16} /> {label}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <a
              data-testid="final-cta-btn"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex w-full items-center justify-center gap-4 bg-[#111111] px-8 py-6 text-center text-lg font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-black sm:text-xl"
            >
              <WhatsAppIcon size={26} />
              Solicitar Guincho Agora
              <ArrowRight size={22} className="transition-transform duration-200 group-hover:translate-x-2" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
